import { getUserPaymentOptions } from "@/features/users/users.queries";
import { TransactionsHistory } from "@/pages/TransactionsHistory";
import { createFileRoute, redirect } from "@tanstack/react-router";
import type { TransactionSearch } from "@validation/customer";

export const Route = createFileRoute("/_layout/history")({
  validateSearch: (search: Record<string, unknown>): TransactionSearch => {
    // Attempt to parse 'page', default to 1 if invalid or missing
    const page = Number(search.page);
    const validatedPage = !isNaN(page) && page > 0 ? Math.floor(page) : 1;

    // Attempt to parse 'limit', default to 10 if invalid or missing
    const limit = Number(search.limit);
    const validatedLimit = !isNaN(limit) && limit > 0 ? Math.floor(limit) : 10;

    return {
      page: validatedPage,
      limit: validatedLimit,
    };
  },
  loaderDeps: ({ search }) => ({
    page: search.page,
    limit: search.limit,
  }),
  loader: async ({ context }) => {
    const { queryClient } = context;
    try {
      await queryClient.ensureQueryData(
        getUserPaymentOptions({ staleTime: 5000 }),
      );
    } catch (error) {
      throw redirect({
        to: "/login",
        search: { msg: `Session Expire Pls Login again` },
      });
    }
  },
  component: TransactionsHistory,
});
